<template>
  <button
    type="button"
    class="w-full text-left p-4 rounded-lg border-2 transition-colors"
    :class="buttonClasses"
    :disabled="disabled"
    @click="emit('select')"
  >
    <div class="flex items-center gap-2">
      <p class="font-medium" :class="disabled ? 'text-gray-400' : 'text-gray-900'">{{ title }}</p>
      <slot name="badge" />
    </div>
    <p class="text-sm" :class="disabled ? 'text-gray-400' : 'text-gray-500'">{{ description }}</p>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  title: string;
  description: string;
  selected: boolean;
  disabled?: boolean;
};

const props = defineProps<Props>();

const buttonClasses = computed(() => {
  if (props.disabled) return 'border-gray-100 bg-gray-50 cursor-not-allowed';
  if (props.selected) return 'border-indigo-600 bg-indigo-50';
  return 'border-gray-200 hover:border-gray-300 hover:bg-gray-50';
});

const emit = defineEmits<{
  select: [];
}>();
</script>
